// extracted by mini-css-extract-plugin
export default {"tooltip":"fID6WFOCYvl6auaA20Ho","isMark":"m_pnSQmh68YwpGQzjjBJ","noMark":"bVBkRWSCFzGj20IrlMY5","r-tooltip":"oh2bxNLGSTkPIVdxdZ3Q","tooltip_truesight":"uYfUfnf7yOUQ2RGRkG2N"};